import './styles.css';
import { bootstrap } from './app/bootstrap';

bootstrap();
